import { API_REQUESTS } from '@/store/actions/admin/api_requests.actions';

const initialState = {
  api_requests: [],
  api_requests_meta: {}
};

export default function users(state = initialState, action) {
  switch (action.type) {
    case API_REQUESTS:
      return {
        ...state,
        api_requests: action.payload.data,
        api_requests_meta: action.payload.meta
      };
    default:
      return state;
  }
}
